import clsx from "clsx"

type LogoProps = {
  width?: string | number
  height?: string | number
  className?: string
}

const Logo = ({ width = 16, height = 16, className }: LogoProps) => {
  return (
    <img
      src="/pix3.png"
      alt="Pix2Bit logo"
      className={clsx(
        `w-${width} h-${height}`,
        className
      )}
    />
  )
}

export { Logo }
